function setPdpAnchorDynamically ({ $anchorContainer, certonaTitleText }) {

	$anchorContainer.find('a').text(certonaTitleText);

}

export default setPdpAnchorDynamically;
